/**
 * Editorial PDP v2 — Vanilla JS
 * Gallery carousel, image swatches, variant picker, ATC, accordions,
 * sticky bar, buy-with bundle, video, FAQ, review slider
 */
(function() {
  'use strict';

  var section = document.querySelector('.ed2-pdp');
  if (!section) return;

  var pjEl = section.querySelector('[data-product-json]');
  var pj = pjEl ? JSON.parse(pjEl.textContent) : null;

  // --- Helpers ---
  function fmtPrice(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function qs(sel, ctx) { return (ctx || section).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || section).querySelectorAll(sel); }

  // ============================================================
  // MOBILE CAROUSEL — Dot Tracking via IntersectionObserver
  // ============================================================
  var carousel = qs('[data-carousel]');
  var dots = qsa('[data-dot-index]');

  if (carousel && dots.length > 1) {
    var slides = carousel.querySelectorAll('.ed2-pdp__gallery-slide');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var idx = parseInt(entry.target.getAttribute('data-slide-index'));
          dots.forEach(function(d) {
            d.classList.toggle('active', parseInt(d.getAttribute('data-dot-index')) === idx);
          });
        }
      });
    }, { root: carousel, threshold: 0.6 });

    slides.forEach(function(slide) { observer.observe(slide); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(dot.getAttribute('data-dot-index'));
        var target = slides[idx];
        if (target) carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      });
    });
  }

  // ============================================================
  // DESKTOP THUMBNAIL GALLERY — Click to swap main image
  // ============================================================
  var galleryMain = qs('[data-gallery-main]');
  var thumbsWrap = qs('[data-gallery-thumbs]');
  var mainItems = galleryMain ? galleryMain.querySelectorAll('.ed2-pdp__gallery-main-item') : [];
  var thumbBtns = thumbsWrap ? thumbsWrap.querySelectorAll('[data-thumb-index]') : [];

  if (thumbsWrap && thumbBtns.length > 0) {
    thumbsWrap.addEventListener('click', function(e) {
      var thumb = e.target.closest('[data-thumb-index]');
      if (!thumb) return;
      var idx = parseInt(thumb.getAttribute('data-thumb-index'));

      mainItems.forEach(function(item) { item.classList.remove('active', 'ed2-pdp__gallery-main-item--zoomed'); });
      thumbBtns.forEach(function(t) { t.classList.remove('active'); });

      var target = galleryMain.querySelector('[data-gallery-index="' + idx + '"]');
      if (target) target.classList.add('active');
      thumb.classList.add('active');
    });
  }

  // ============================================================
  // DESKTOP IMAGE ZOOM (click to toggle)
  // ============================================================
  if (galleryMain) {
    galleryMain.addEventListener('click', function(e) {
      if (window.innerWidth <= 960) return;
      var item = e.target.closest('.ed2-pdp__gallery-main-item');
      if (!item) return;
      var img = item.querySelector('img');
      if (!img) return;

      if (item.classList.contains('ed2-pdp__gallery-main-item--zoomed')) {
        item.classList.remove('ed2-pdp__gallery-main-item--zoomed');
      } else {
        mainItems.forEach(function(g) { g.classList.remove('ed2-pdp__gallery-main-item--zoomed'); });
        var rect = item.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width * 100) + '%';
        var y = ((e.clientY - rect.top) / rect.height * 100) + '%';
        item.style.setProperty('--zoom-x', x);
        item.style.setProperty('--zoom-y', y);
        item.classList.add('ed2-pdp__gallery-main-item--zoomed');
      }
    });
  }

  // ============================================================
  // QUANTITY SELECTOR
  // ============================================================
  section.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    var input = section.querySelector('[data-qty-input]');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    input.value = Math.max(1, val + parseInt(btn.getAttribute('data-qty-btn')));
    var formQty = section.querySelector('[data-form-qty]');
    if (formQty) formQty.value = input.value;
  });

  // ============================================================
  // VARIANT PICKER (with image swatches support)
  // ============================================================
  if (pj) {
    section.addEventListener('click', function(e) {
      var btn = e.target.closest('.ed2-pdp__swatch, .ed2-pdp__size-btn');
      if (!btn || btn.classList.contains('disabled')) return;

      var parent = btn.closest('.ed2-pdp__option');
      parent.querySelectorAll('.ed2-pdp__swatch, .ed2-pdp__size-btn').forEach(function(b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');

      var lbl = parent.querySelector('[data-option-value]');
      if (lbl) lbl.textContent = btn.getAttribute('data-option-value');

      var opts = [];
      qsa('.ed2-pdp__option').forEach(function(og) {
        var active = og.querySelector('.ed2-pdp__swatch.active, .ed2-pdp__size-btn.active');
        if (active) opts.push(active.getAttribute('data-option-value'));
      });

      var match = pj.variants.find(function(v) {
        return v.options.every(function(o, i) { return o === opts[i]; });
      });

      if (match) {
        var vidInput = qs('[data-variant-id]');
        if (vidInput) vidInput.value = match.id;

        var priceEl = qs('[data-current-price]');
        var compareEl = qs('[data-compare-price]');
        var stickyPrice = qs('[data-sticky-price]');
        if (priceEl) priceEl.textContent = fmtPrice(match.price);
        if (stickyPrice) stickyPrice.textContent = fmtPrice(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = fmtPrice(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        var atcBtn = qs('[data-atc-btn]');
        var atcText = qs('[data-atc-text]');
        var stickyBtn = qs('[data-sticky-atc-btn]');
        if (atcBtn) atcBtn.disabled = !match.available;
        if (stickyBtn) stickyBtn.disabled = !match.available;
        if (atcText) atcText.textContent = match.available ? 'Add to cart \u2013 ' + fmtPrice(match.price) : 'Sold Out';

        if (history.replaceState) {
          history.replaceState({}, '', window.location.pathname + '?variant=' + match.id);
        }

        if (match.featured_media) {
          swapGalleryToMedia(match.featured_media.id);
        }
      }
    });
  }

  function swapGalleryToMedia(mediaId) {
    // Desktop: activate the matching main image + thumbnail
    if (window.innerWidth > 960 && galleryMain) {
      var targetMain = galleryMain.querySelector('[data-media-id="' + mediaId + '"]');
      if (targetMain) {
        mainItems.forEach(function(item) { item.classList.remove('active', 'ed2-pdp__gallery-main-item--zoomed'); });
        targetMain.classList.add('active');
      }
      if (thumbsWrap) {
        var targetThumb = thumbsWrap.querySelector('[data-media-id="' + mediaId + '"]');
        thumbBtns.forEach(function(t) { t.classList.remove('active'); });
        if (targetThumb) targetThumb.classList.add('active');
      }
    }
    // Mobile: scroll carousel to the matching slide
    var slide = qs('.ed2-pdp__gallery-slide[data-media-id="' + mediaId + '"]');
    if (slide && carousel && window.innerWidth <= 960) {
      carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
  }

  // ============================================================
  // STICKY ATC
  // ============================================================
  var stickyBtn = qs('[data-sticky-atc-btn]');
  var form = qs('[data-product-form]');
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function() {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    });
  }

  // ============================================================
  // ACCORDION (buybox)
  // ============================================================
  qsa('[data-accordion]').forEach(function(acc) {
    var trigger = acc.querySelector('.ed2-pdp__accordion-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function() {
      var isOpen = acc.classList.contains('open');
      qsa('[data-accordion]').forEach(function(a) {
        a.classList.remove('open');
        var t = a.querySelector('.ed2-pdp__accordion-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        acc.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ============================================================
  // STICKY ATC BAR VISIBILITY (Mobile)
  // ============================================================
  var mainAtc = qs('[data-atc-btn]');
  var stickyBar = qs('[data-sticky-atc]');

  if (mainAtc && stickyBar) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        // Only show when user scrolled PAST the button (top < 0 = above viewport)
        // Don't show when button is still below the fold on initial load
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('visible', scrolledPast);
      });
    }, { threshold: 0 });
    stickyObserver.observe(mainAtc);
  }

  // ============================================================
  // SCROLL TO REVIEWS
  // ============================================================
  var reviewsBadge = qs('[data-scroll-to-reviews]');
  if (reviewsBadge) {
    reviewsBadge.addEventListener('click', function() {
      var reviewsSection = document.querySelector('.ed2-reviews');
      if (reviewsSection) reviewsSection.scrollIntoView({ behavior: 'smooth' });
    });
  }

  // ============================================================
  // SIZE CHART — inline toggle panel
  // ============================================================
  // Use document-level delegation to avoid label/scope issues
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-size-chart-toggle]');
    if (!toggle) return;
    e.preventDefault();
    e.stopPropagation();
    var panel = document.querySelector('[data-size-chart-panel]');
    if (panel) panel.classList.toggle('open');
  });

  // ============================================================
  // COUNTDOWN TIMER
  // ============================================================
  var countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    var endDateStr = countdownEl.getAttribute('data-end-date');
    var display = countdownEl.querySelector('[data-countdown-display]');
    var target;
    if (endDateStr) {
      target = new Date(endDateStr + 'T23:59:59').getTime();
    } else {
      var now = new Date();
      target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime();
    }
    function updateCountdown() {
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      display.textContent = String(d).padStart(2,'0') + ' Days : ' +
        String(h).padStart(2,'0') + ' Hrs : ' +
        String(m).padStart(2,'0') + ' Mins : ' +
        String(s).padStart(2,'0') + ' Secs';
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

})();

// ============================================================
// FAQ ACCORDION (outside PDP section scope)
// ============================================================
(function() {
  'use strict';
  var faqItems = document.querySelectorAll('.ed2-faq__item');
  faqItems.forEach(function(item) {
    var trigger = item.querySelector('.ed2-faq__question');
    if (!trigger) return;
    trigger.addEventListener('click', function() {
      var isOpen = item.classList.contains('open');
      // Close all others
      faqItems.forEach(function(i) {
        i.classList.remove('open');
        var t = i.querySelector('.ed2-faq__question');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

// ============================================================
// YOU'LL ALSO LOVE — Card grid + variant picker popup
// ============================================================
(function() {
  'use strict';
  var wrap = document.querySelector('.ed2-buywith');
  if (!wrap) return;

  var cards = wrap.querySelectorAll('[data-buywith-card]');
  var popup = wrap.querySelector('[data-buywith-popup]');
  var popupImg = wrap.querySelector('[data-buywith-popup-img]');
  var popupName = wrap.querySelector('[data-buywith-popup-name]');
  var popupPrice = wrap.querySelector('[data-buywith-popup-price]');
  var popupOptions = wrap.querySelector('[data-buywith-popup-options]');
  var popupAtc = wrap.querySelector('[data-buywith-popup-atc]');

  // Product data cache keyed by handle
  var productCache = {};
  // Current popup state
  var popupState = { product: null, selected: {}, variantId: null };

  function fmtP(cents) { return '$' + (cents / 100).toFixed(2); }

  // --- Guess option name from values ---
  function guessOptionName(values, index) {
    if (values.some(function(v) { return /^(XXS|XS|S|M|L|XL|XXL|2XL|3XL|\d{1,2})$/i.test(v); }))
      return 'Size';
    if (values.some(function(v) { return /^(red|blue|green|black|white|gold|pink|wine|navy|cream|grey|gray|beige|ivory|brown|oatmeal|sage|dusty|charcoal|mocha|olive|taupe|sand|sky|rose|lavender|mint|coral|teal|plum|rust|burgundy|mauve|slate|stone|camel|tan|honey|linen|fog|mist|cloud|pearl)/i.test(v); }))
      return 'Color';
    return 'Option ' + (index + 1);
  }

  // --- Extract unique options from variants ---
  function extractOptions(product) {
    var options = [];
    if (!product.variants || product.variants.length <= 1) return options;

    // Shopify products have option1, option2, option3
    var optionNames = product.options || [];
    for (var i = 0; i < optionNames.length; i++) {
      var key = 'option' + (i + 1);
      var seen = {};
      var values = [];
      product.variants.forEach(function(v) {
        var val = v[key];
        if (val && !seen[val]) {
          seen[val] = true;
          values.push(val);
        }
      });
      if (values.length > 1) {
        var name = optionNames[i] || guessOptionName(values, i);
        options.push({ key: key, name: name, values: values });
      }
    }
    return options;
  }

  // --- Find matching variant ---
  function findVariant(product, selected) {
    return product.variants.find(function(v) {
      for (var key in selected) {
        if (v[key] !== selected[key]) return false;
      }
      return true;
    });
  }

  // --- Update popup price + ATC state ---
  function updatePopupVariant() {
    var prod = popupState.product;
    if (!prod) return;
    var v = findVariant(prod, popupState.selected);
    if (v) {
      popupState.variantId = v.id;
      popupPrice.textContent = fmtP(v.price);
      popupAtc.disabled = !v.available;
      popupAtc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
    } else {
      popupState.variantId = null;
      popupAtc.disabled = true;
      popupAtc.textContent = 'Unavailable';
    }
  }

  // --- Render option groups ---
  function renderOptions(product) {
    popupOptions.innerHTML = '';
    var options = extractOptions(product);
    if (options.length === 0) {
      // Single variant — no options to pick
      var v = product.variants[0];
      popupState.variantId = v.id;
      popupAtc.disabled = !v.available;
      popupAtc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      return;
    }

    // Pre-select first available variant's options
    var firstAvail = product.variants.find(function(v) { return v.available; }) || product.variants[0];
    options.forEach(function(opt) {
      popupState.selected[opt.key] = firstAvail[opt.key];
    });

    options.forEach(function(opt) {
      var group = document.createElement('div');
      group.className = 'ed2-buywith__popup-opt-group';

      var label = document.createElement('span');
      label.className = 'ed2-buywith__popup-opt-label';
      label.textContent = opt.name;
      group.appendChild(label);

      var valuesWrap = document.createElement('div');
      valuesWrap.className = 'ed2-buywith__popup-opt-values';

      opt.values.forEach(function(val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ed2-buywith__popup-opt-btn';
        btn.textContent = val;
        btn.setAttribute('data-opt-key', opt.key);
        btn.setAttribute('data-opt-val', val);

        if (popupState.selected[opt.key] === val) btn.classList.add('active');

        // Check if any variant with this value is available
        var hasAvailable = product.variants.some(function(v) {
          return v[opt.key] === val && v.available;
        });
        if (!hasAvailable) btn.classList.add('unavailable');

        valuesWrap.appendChild(btn);
      });

      group.appendChild(valuesWrap);
      popupOptions.appendChild(group);
    });

    updatePopupVariant();
  }

  // --- Open popup ---
  function openPopup(handle) {
    var prod = productCache[handle];
    if (!prod) return;

    popupState.product = prod;
    popupState.selected = {};
    popupState.variantId = null;

    popupImg.src = prod.featured_image || '';
    popupImg.alt = prod.title;
    popupName.textContent = prod.title;

    var v = prod.variants.find(function(vr) { return vr.available; }) || prod.variants[0];
    popupPrice.textContent = fmtP(v.price);

    renderOptions(prod);

    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    popupAtc.textContent = 'Add to Cart';
  }

  // --- Close popup ---
  function closePopup() {
    popup.style.display = 'none';
    document.body.style.overflow = '';
    popupState.product = null;
  }

  // --- Fetch and populate cards ---
  cards.forEach(function(card) {
    var handle = card.getAttribute('data-handle');
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(prod) {
        productCache[handle] = prod;
        var v = prod.variants.find(function(vr) { return vr.available; }) || prod.variants[0];
        card.setAttribute('data-variant-id', v.id);

        var links = card.querySelectorAll('[data-buywith-link]');
        links.forEach(function(link) { link.href = prod.url; });

        var imgWrap = card.querySelector('.ed2-buywith__card-img-wrap');
        if (imgWrap && prod.featured_image) {
          var placeholder = imgWrap.querySelector('.ed2-buywith__card-img-placeholder');
          if (placeholder) placeholder.remove();
          var img = document.createElement('img');
          img.src = prod.featured_image;
          img.alt = prod.title;
          img.loading = 'lazy';
          imgWrap.appendChild(img);
        }

        var titleEl = card.querySelector('.ed2-buywith__card-title');
        if (titleEl) titleEl.textContent = prod.title;

        var priceEl = card.querySelector('[data-buywith-price]');
        if (priceEl) priceEl.textContent = fmtP(v.price);

        var compareEl = card.querySelector('[data-buywith-compare]');
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = fmtP(v.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      })
      .catch(function() {
        card.style.display = 'none';
      });
  });

  // --- ATC icon click → open variant popup ---
  wrap.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-buywith-card-atc]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-buywith-card]');
    var handle = card ? card.getAttribute('data-handle') : null;
    if (handle) openPopup(handle);
  });

  // --- Option pill click ---
  if (popupOptions) {
    popupOptions.addEventListener('click', function(e) {
      var btn = e.target.closest('.ed2-buywith__popup-opt-btn');
      if (!btn || btn.classList.contains('unavailable')) return;

      var key = btn.getAttribute('data-opt-key');
      var val = btn.getAttribute('data-opt-val');
      popupState.selected[key] = val;

      // Update active state for this group
      var group = btn.closest('.ed2-buywith__popup-opt-group');
      group.querySelectorAll('.ed2-buywith__popup-opt-btn').forEach(function(b) {
        b.classList.toggle('active', b.getAttribute('data-opt-val') === val);
      });

      updatePopupVariant();
    });
  }

  // --- Popup ATC click ---
  if (popupAtc) {
    popupAtc.addEventListener('click', function() {
      if (!popupState.variantId) return;
      popupAtc.disabled = true;
      popupAtc.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(popupState.variantId), quantity: 1 }] })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        popupAtc.textContent = 'Added!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(closePopup, 1000);
      })
      .catch(function() {
        popupAtc.disabled = false;
        popupAtc.textContent = 'Add to Cart';
      });
    });
  }

  // --- Close popup events ---
  wrap.querySelectorAll('[data-buywith-popup-close]').forEach(function(el) {
    el.addEventListener('click', closePopup);
  });
})();

// ============================================================
// VIDEO SECTION — YouTube/Vimeo click-to-play
// ============================================================
(function() {
  'use strict';
  var videoSections = document.querySelectorAll('.ed2-video__player[data-video-url]');
  videoSections.forEach(function(player) {
    var poster = player.querySelector('.ed2-video__poster');
    if (!poster) return;

    poster.addEventListener('click', function() {
      var url = player.getAttribute('data-video-url');
      var embedUrl = parseVideoUrl(url);
      if (!embedUrl) return;

      var iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      poster.style.display = 'none';
      player.appendChild(iframe);
    });
  });

  function parseVideoUrl(url) {
    if (!url) return null;
    // YouTube
    var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
    if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
    // Vimeo
    var vmMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vmMatch) return 'https://player.vimeo.com/video/' + vmMatch[1] + '?autoplay=1';
    return null;
  }
})();

// ============================================================
// REVIEW SLIDER DOTS (mobile)
// ============================================================
(function() {
  'use strict';
  var reviewGrid = document.querySelector('.ed2-reviews__grid');
  var reviewDots = document.querySelectorAll('.ed2-reviews__dot');
  if (!reviewGrid || reviewDots.length < 2) return;

  var cards = reviewGrid.querySelectorAll('.ed2-reviews__card');
  var reviewObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var idx = Array.prototype.indexOf.call(cards, entry.target);
        reviewDots.forEach(function(d, i) {
          d.classList.toggle('active', i === idx);
        });
      }
    });
  }, { root: reviewGrid, threshold: 0.6 });

  cards.forEach(function(card) { reviewObserver.observe(card); });

  reviewDots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      if (cards[i]) {
        reviewGrid.scrollTo({ left: cards[i].offsetLeft - reviewGrid.offsetLeft, behavior: 'smooth' });
      }
    });
  });
})();

// ============================================================
// RELATED PRODUCTS (Fetch Recommendations)
// ============================================================
(function() {
  'use strict';
  function fmtPrice(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  var relatedTrack = document.querySelector('.ed2-related__track[data-product-id]');
  if (!relatedTrack) return;

  var productId = relatedTrack.getAttribute('data-product-id');
  fetch('/recommendations/products.json?product_id=' + productId + '&limit=8')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.products || !data.products.length) return;
      var html = '';
      data.products.forEach(function(prod) {
        var img = prod.featured_image ? prod.featured_image : '';
        html += '<a href="' + prod.url + '" class="ed2-related__card">' +
          '<img class="ed2-related__card-img" src="' + img + '" alt="' + (prod.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
          '<div class="ed2-related__card-title">' + prod.title + '</div>' +
          '<div class="ed2-related__card-price">' + fmtPrice(prod.price) + '</div>' +
        '</a>';
      });
      relatedTrack.innerHTML = html;
    })
    .catch(function() {});
})();

// ============================================================
// NEWSLETTER FORM
// ============================================================
(function() {
  'use strict';
  var nlForm = document.querySelector('.ed2-newsletter__form');
  if (!nlForm) return;

  nlForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var input = nlForm.querySelector('.ed2-newsletter__input');
    var success = nlForm.parentElement.querySelector('.ed2-newsletter__success');
    if (!input || !input.value) return;

    var formData = new FormData();
    formData.append('form_type', 'customer');
    formData.append('utf8', '\u2713');
    formData.append('customer[email]', input.value);
    formData.append('customer[tags]', 'newsletter');

    fetch('/contact', { method: 'POST', body: formData })
      .then(function() {
        input.value = '';
        if (success) {
          success.style.display = 'block';
          success.textContent = 'Thanks for subscribing!';
        }
      })
      .catch(function() {
        if (success) {
          success.style.display = 'block';
          success.textContent = 'Something went wrong. Please try again.';
          success.style.color = 'var(--ed2-error)';
        }
      });
  });
})();
